import { Button, Card, Form, Input, message, Modal, Select, Space, Table, TablePaginationConfig, Tabs, TabsProps, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useId24 } from "../../../drivers/id24/Id24Provider";
import { Activityservice } from "../services/importfile.service";
import { ActivityListGenerateQr } from "../components/activity-list-generateqr";
import type { ColumnsType } from "antd/es/table";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { UserEventService } from "../../../api/user.service";
import { useForm } from "antd/es/form/Form";
import { loadAppConfig } from "../../../configs/app-config";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { SorterResult } from "antd/es/table/interface";
import { CustomerUrlService } from "../../../api/customer-url.service";
dayjs.extend(buddhistEra);
dayjs.locale("th");

type TUsers = {
  id: number;
  userId: string;
  numberId: string;
  fullName: string;
  email: string;
  company: string;
  department: string;
  position: string;
  phone: string;
  qrcodeId: string;
  confirmStatus: false;
  registerStatus: false;
  seatno: null;
  registerDate: string;
  agendaId: string;
  createDate: string | Date;
  updateDate: string | Date;
  dataSource: any;
};

export type TDinamicSort = { column: string | number | bigint | undefined; order: "desc" | "asc" | undefined };

export const ActivityListMember: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const [formWristband] = useForm();
  const [formSearch] = useForm();
  const param = useParams<{ agendaId: string }>();
  const [loading, setLoading] = useState<boolean>(true);
  const [usersData, setUsersData] = useState<{ total: number; users: TUsers[] }>({ total: 0, users: [] });
  const [pagination, setPagination] = useState<{ current: number; pageSize: number; sortOrder?: TDinamicSort }>({
    current: 1,
    pageSize: 10,
    sortOrder: { column: undefined, order: undefined },
  });
  const [formUpdate] = useForm();
  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [userData, setUserData] = useState<any>();
  const [dataDropDown, setDataDropDown] = useState<[]>([]);
  const [typeUser, setTypeUser] = useState<string>("");

  const columns: ColumnsType<TUsers> = [
    {
      title: "No.",
      dataIndex: "id",
      key: "id",
      width: "5%",
      render: (value, record, index) => index + 1 + (pagination.current - 1) * pagination.pageSize,
    },
    {
      key: "id",
      title: "Check",
      dataIndex: "id",
      width: "5%",
      render: (value, record: TUsers, index) => {
        return !record.confirmStatus ? (
          <Button size="small" type="primary" onClick={() => checkIn(record)}>
            Check In
          </Button>
        ) : (
          <Button size="small" type="primary" danger onClick={() => removeCheckIn(record)}>
            Remove Check In
          </Button>
        );
      },
    },
    {
      key: "id",
      title: "Set Wristband",
      dataIndex: ["dataSource", "wristbandId"],
      width: "8%",
      render: (value, record: TUsers, index) => {
        return (
          <Space>
            <Tag>{value ? value : "-"}</Tag>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                formWristband.setFieldValue("wristbandId", value);
                setUserData(record);
                setIsModalOpen(true);
              }}
            >
              Set
            </Button>
          </Space>
        );
      },
    },
    {
      key: "id",
      title: "Type",
      dataIndex: ["dataSource", "type"],
      width: "5%",
      render: (value, record: TUsers, index) => {
        let rename;
        let color;
        if (value) {
          rename = value === "A" ? "General" : value === "B" ? "Partners" : "Vip";
          color = value === "A" ? "volcano" : value === "B" ? "purple" : "blue";
        } else {
          rename = "-";
        }
        return (
          <Space>
            <Tag color={color}>{rename}</Tag>
          </Space>
        );
      },
    },
    {
      key: "id",
      title: "Change Type",
      dataIndex: ["dataSource", "type"],
      width: "10%",
      render: (value, record: TUsers, index) => {
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                setUserData(record);
                showModal(record);
              }}
            >
              Edit
            </Button>
          </Space>
        );
      },
    },
    {
      key: "numberId",
      title: "Ticket Number",
      dataIndex: "numberId",
      width: "10%",
      sorter: true,
      showSorterTooltip: false,
    },
    {
      key: "id",
      title: "Full Name",
      dataIndex: ["dataSource", "fullname"],
      width: "10%",
    },
    {
      key: "id",
      title: "Position",
      dataIndex: ["dataSource", "position"],
      width: "10%",
      render: (value, record, index) => {
        return !value ? "_" : value;
      },
    },
    {
      key: "id",
      title: "company",
      dataIndex: ["dataSource", "company"],
      width: "10%",
      render: (value, record, index) => {
        return !value ? "_" : value.label;
      },
    },
    {
      key: "id",
      title: "Email",
      dataIndex: ["dataSource", "businessEmail"],
      width: "10%",
      render: (value, record, index) => {
        return !value ? "_" : value;
      },
    },
    {
      key: "id",
      title: "Phone Number",
      dataIndex: ["dataSource", "phoneNumber"],
      width: "10%",
      render: (value, record, index) => {
        return !value ? "_" : value;
      },
    },
    {
      key: "id",
      title: "Business Type",
      dataIndex: ["dataSource", "businessType"],
      width: "10%",
      render: (value, record, index) => {
        return !value ? "_" : value.label;
      },
    },
    {
      key: "createDate",
      title: "Created",
      dataIndex: "createDate",
      width: "10%",
      sorter: true,
      showSorterTooltip: false,
      render: (value, record, index) => {
        return value ? dayjs(value).format("BBBB-MM-DD hh:mm:ss") : "-";
      },
    },
  ];
  const showModal = async (user: TUsers) => {
    const result = await CustomerUrlService(apiBaseUrl).getDropDown();
    setDataDropDown(result);
    setTypeUser(user.dataSource.type);
    formUpdate.setFieldValue("company", user.dataSource.company.label);
    formUpdate.setFieldValue("type", user.dataSource.type);
    setOpen(true);
  };

  const onUplevel = async (record: any) => {
    const companyData = dataDropDown.find((item: any) => item.customerNumber === record.company) as any;
    const companyType =
      record.type === "A"
        ? { label: record.company }
        : {
            value: record.company,
            label: companyData?.customerName,
          };

    const data = {
      ...userData.dataSource,
      type: record.type,
      company: companyType,
    };
    try {
      if (param.agendaId) {
        await UserEventService(apiBaseUrl).updateByEvent(userData.userId, data);
        message.success("success");
        setLoading(true);
        setOpen(false);
      }
    } catch (err) {
      setOpen(false);
      console.log(err);
    }
  };

  const validateFormat = (value: string) => {
    const regex = /^(A|B|V)-(\d{4})$/;
    const match = value.match(regex);

    if (!match) return false;

    const [, , num] = match;
    const numInt = parseInt(num, 10);

    return numInt >= 1 && numInt <= 200;
  };

  const onValidateWristbandId = async (wristbandId: string): Promise<string | undefined> =>
    param.agendaId && UserEventService(apiBaseUrl).validateWristbandId(param.agendaId, wristbandId);

  const onSetWristband = async (event: { wristbandId: string }) => {
    const data = { ...userData.dataSource, wristbandId: event.wristbandId };
    try {
      if (param.agendaId) {
        await UserEventService(apiBaseUrl).updateByEvent(userData.userId, data);
        message.success("success");
        setLoading(true);
        setIsModalOpen(false);
      }
    } catch (err) {
      setIsModalOpen(false);
      console.log(err);
    }
  };

  useEffect(() => {
    if (loading) featchData();
  }, [loading]);

  const exportToExcel = async () => {
    try {
      if (param.agendaId) {
        const searchParam = {
          username: formSearch.getFieldValue("username"),
          ticket: formSearch.getFieldValue("ticket"),
          type: formSearch.getFieldValue("type"),
        };
        const result = await Activityservice(apiBaseUrl).exportUserInAgnedaId(param.agendaId, searchParam);

        const worksheet = XLSX.utils.json_to_sheet(result);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const dataBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });

        saveAs(dataBlob, `${dayjs(new Date()).format("BBBB-MM-DD hh:mm:ss")}.xlsx`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // useEffect(() => {
  //   getColumn();
  // }, []);

  // const getColumn = async () => {
  //   const result = await Activityservice(apiBaseUrl).findUserInAgneda(param.agendaId, 0, 10, {});
  //   if (Number(result.total)) {
  //     const dataSourceKeys = Object.keys(result.users[0].dataSource).map((key) => {
  //       const value = result.users[0].dataSource[key];
  //       const type = typeof value;

  //       if (key !== "type" && key !== "ticketNumber") {
  //         return {
  //           key,
  //           title: key,
  //           dataIndex: ["dataSource", key],
  //           width: "10%",
  //           render: (text: any, record: any) => {
  //             if (!text) return "_";
  //             return type === "object" ? text.label : text;
  //           },
  //         };
  //       } else {
  //         return {};
  //       }
  //     });
  //     setColumn(dataSourceKeys);
  //   }
  // };

  const featchData = async () => {
    const skip = (Number(pagination.current) - 1) * Number(pagination.pageSize);
    const take = Number(pagination.pageSize);
    let column;
    if (pagination.sortOrder?.column === "numberId") {
      column = "u.number_id";
    } else if (pagination.sortOrder?.column === "createDate") {
      column = "u.create_date";
    } else {
      column = undefined;
    }
    const searchParam = {
      username: formSearch.getFieldValue("username"),
      ticket: formSearch.getFieldValue("ticket"),
      type: formSearch.getFieldValue("type"),
      order: pagination.sortOrder?.order,
      column: column,
      customerName: formSearch.getFieldValue("customerName"),
    };
    const result = await Activityservice(apiBaseUrl).findUserInAgneda(param.agendaId, skip, take, searchParam);
    setUsersData(result);
    setLoading(false);
  };

  const onChangeTable = (pagination: TablePaginationConfig, sortOrder: SorterResult<TUsers>) => {
    const { current, pageSize } = pagination;
    setPagination({
      current: current || 1,
      pageSize: pageSize || 10,
      sortOrder: { order: sortOrder.order === "descend" ? "desc" : sortOrder.order === "ascend" ? "asc" : undefined, column: sortOrder.columnKey },
    });
    setLoading(true);
  };

  const checkIn = async (record: TUsers) => {
    await Activityservice(apiBaseUrl).checkIn(record.userId);
    message.success("success");
    setLoading(true);
  };

  const removeCheckIn = async (record: TUsers) => {
    await Activityservice(apiBaseUrl).removeCheckIn(record.userId);
    message.success("success");
    setLoading(true);
  };

  const onSearch = async () => {
    setLoading(true);
  };

  // { key: "id", title: "ชื่อ", dataIndex: ["dataSource", "fullname"], width: "10%" },
  // { key: "id", title: "เลขบัตรประชาชน", dataIndex: "Taxpayer", width: "10%" },
  // { key: "id", title: "อายุ", dataIndex: "paymentTuambun", width: "10%" },
  // { key: "id", title: "เบอร์โทร", dataIndex: "phone", width: "10%" },
  // {
  //   key: "id",
  //   title: "ผู้สูงอายุจากชุมชน",
  //   dataIndex: "position",
  //   width: "10%",
  // },
  // {
  //   key: "id",
  //   title: "วัดสังกัด(เฉพาะพระสงฆ์)",
  //   dataIndex: "company",
  //   width: "10%",
  // },
  // { key: "id", title: "หมายเหดุ", dataIndex: "address", width: "10%" },

  // {
  //   key: "id",
  //   title: "Update Date",
  //   dataIndex: "updateDate",
  //   width: "10%",
  //   render: (value, record, index) => {
  //     dayjs.locale("th");
  //     return dayjs(value).format("DD-MM-BBBB HH:mm:ss");
  //   },
  // },
  // {
  //   key: "id",
  //   title: "Create Date",
  //   dataIndex: "createDate",
  //   width: "10%",
  //   render: (value, record, index) => {
  //     dayjs.locale("th");
  //     return dayjs(value).format("DD-MM-BBBB HH:mm:ss");
  //   },
  // },
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Generate qr",
      children: <ActivityListGenerateQr />,
    },
    {
      key: "2",
      label: "Users",
      children: (
        <>
          <div className=" pb-2">
            <Form form={formSearch} name="horizontal_login" layout="inline" onFinish={onSearch}>
              <Form.Item className=" m-1" label={"Username"} name={"username"}>
                <Input placeholder="Username" />
              </Form.Item>
              <Form.Item className=" m-1" label={"Ticket"} name={"ticket"}>
                <Input placeholder="Ticket" />
              </Form.Item>
              <Form.Item className=" m-1" label={"Type"} name={"type"}>
                <Select
                  placeholder="Select Type"
                  className="w-full"
                  options={[
                    { value: "A", label: "General" },
                    { value: "B", label: "Partners" },
                    { value: "V", label: "Vip" },
                  ]}
                />
              </Form.Item>
              <Form.Item className=" m-1" label={"Customer Name"} name={"customerName"}>
                <Input />
              </Form.Item>
              <Form.Item className=" m-1">
                <Button type="primary" htmlType="submit">
                  Search
                </Button>
              </Form.Item>
            </Form>
          </div>
          <div className=" flex justify-end pb-2">
            <Button onClick={exportToExcel} type="primary">
              Export to Excel
            </Button>
          </div>
          <Table
            size="small"
            loading={loading}
            dataSource={usersData.users}
            columns={columns}
            scroll={{ x: 1700 }}
            rowKey={`id`}
            onChange={(pagination, filters, sorter: SorterResult<TUsers> | SorterResult<TUsers>[]) => {
              if (!Array.isArray(sorter)) {
                onChangeTable(pagination, sorter);
              }
            }}
            pagination={{
              ...pagination,
              defaultPageSize: 10,
              total: usersData.total,
              showSizeChanger: true,
            }}
          />
        </>
      ),
    },
  ];

  const onChangeType = async (value: string) => {
    setTypeUser(value);
  };

  return (
    <div>
      {contextHolder}
      <Card>
        <Tabs defaultActiveKey="1" items={items} />
      </Card>
      <Modal open={isModalOpen} footer={[]} onCancel={() => setIsModalOpen(false)}>
        <Form form={formWristband} name="horizontal_wrisbrand" layout="inline" onFinish={onSetWristband}>
          <Form.Item
            className=" m-1"
            label={"Wristband ID"}
            name={"wristbandId"}
            rules={[
              { required: true, message: "Please input your Wristband ID!" },
              {
                validator: async (_, value) => {
                  if (value) {
                    if (validateFormat(value)) {
                      const validationFailReason = await onValidateWristbandId(value);
                      if (validationFailReason) {
                        throw new Error(validationFailReason);
                      }
                    } else {
                      throw new Error("Wristband ID format not found!!");
                    }
                  }
                },
              },
            ]}
          >
            <Input placeholder="Enter (e.g., A-0001 B-0001 C-0001)" />
          </Form.Item>
          <Form.Item className=" m-1">
            <Button type="primary" htmlType="submit">
              Confrim
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Change Type"
        open={open}
        footer={[]}
        onCancel={() => {
          setOpen(false);
          formUpdate.resetFields();
        }}
      >
        <Form form={formUpdate} onFinish={onUplevel}>
          <Form.Item name={"type"} label="Type">
            <Select
              onChange={onChangeType}
              placeholder="Select Type"
              className="w-full"
              options={[
                { value: "A", label: "General" },
                { value: "B", label: "Partners" },
                { value: "V", label: "Vip" },
              ]}
            />
          </Form.Item>
          <Form.Item name={"company"} label="Company">
            {typeUser === "A" ? (
              <Input />
            ) : (
              <Select
                placeholder="Select Type"
                className="w-full"
                showSearch
                options={dataDropDown.map((item: any) => ({ label: item.customerName, value: item.customerNumber }))}
                filterOption={(input, option) => option?.label.toLowerCase().includes(input.toLowerCase())}
              />
            )}
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
